import { useQuery } from "react-query";
import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { InvoiceStatement } from "../../models";

export const useInvoiceStatementsOwingByCustomer = (customerId?: string) => {
  return useQuery<InvoiceStatement[], Error>(
    RQ.INVOICE_STATEMENTS_OWING_BY_CUSTOMER,
    async () =>
      getAll<InvoiceStatement>(`invoice-statements/owing/${customerId}`),
    {
      enabled: Boolean(customerId),
    }
  );
};
